module.exports = __webpack_public_path__ + "static/media/check.f67cde49.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/check.svg
// module id = 261
// module chunks = 0